export default __webpack_public_path__ + "static/media/ir.9f951dd0.svg";